var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.preview)?_c('video',{key:_vm.conf.componentId,class:'tmVideo' + _vm.conf.componentId,style:({
    objectFit: 'fill',
    borderRadius: _vm.conf.borderRadius + '%',
    'pointer-events': 'none'
  }),attrs:{"controls":"controls","autoplay":"autoplay","muted":"muted","width":"100%","height":"100%","src":_vm.conf.videoList[0].url},domProps:{"muted":true}}):_c('video',{key:_vm.conf.componentId,class:'tmVideo' + _vm.conf.componentId,style:({
    objectFit: 'fill',
    borderRadius: _vm.conf.borderRadius + '%'
  }),attrs:{"autoplay":"autoplay","muted":"muted","width":"100%","height":"100%","src":_vm.conf.videoList[0].url},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }